import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, roles, allowTeamLeaders = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#E31837]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has the required role OR is a team leader (when allowTeamLeaders is true)
  const hasRequiredRole = roles ? roles.includes(user.role) : true;
  const isTeamLeaderAllowed = allowTeamLeaders && user.is_team_leader;
  
  if (roles && !hasRequiredRole && !isTeamLeaderAllowed) {
    return <Navigate to="/" replace />;
  }

  return children;
};
